import React, { useState, useEffect } from 'react'
import NhatKyDangNhapApi from '../../../api/NhatKyDangNhapApi';
import { Modal, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Pagination from 'react-bootstrap-4-pagination';
import ThongBao from '../../../core/ThongBao';
import Authen from '../../../core/Authen';

export const NhatKyDangNhap = () => {
    const [listNhomQuyens, setNhomQuyen] = useState([]);
    const [filter, setFilter] = useState('');

    let pageIndex = 1;
    let pageSize = 20;
    const [paginationConfig, setPaging] = useState({
        totalPages: 1,
        currentPage: 1,
        showMax: 5,
        size: "sm",
        threeDots: true,
        prevNext: true,
        onClick: function (page) {
            pageIndex = page;
            loadNhomQuyen();
        }
    });

    const loadNhomQuyen = async () => {
        try {
            const params = {
                pageIndex: pageIndex,
                pageSize: pageSize,
                keyword: filter
            }
            const response = await NhatKyDangNhapApi.getPaging(params);
            response.Items.forEach(item => {
                item.Checked = false;
            });
            paginationConfig.totalPages = Math.ceil(response.TotalRow / pageSize);
            if(response.TotalRow ==0){
                paginationConfig.totalPages =1;
            }
            paginationConfig.currentPage = pageIndex;
            setPaging(paginationConfig);
            setNhomQuyen(response.Items);
        } catch (err) {
        }
    }

    useEffect(() => {
        loadNhomQuyen();
    }, []);

    const timKiem = () => {
        loadNhomQuyen();
    }

    function onChangeFilter(e) {
        setFilter(e.target.value)
    }
 
    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2 row">
                <div className="col-md-4">
                    <h6 className="m-0 font-weight-bold text-primary">Nhật ký đăng nhập</h6>
                </div>
                <div className="input-group col-md-4">
                    <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={onChangeFilter} />
                    <div className="input-group-append">
                        <button className="btn btn-info" type="button" onClick={timKiem}><i className='fas fa-search'></i> Tìm kiếm</button>
                    </div>
                </div>
                <div className="col-md-4 bd-button text-right">
                    {/* {roleDel == true ?<Button variant="danger" size="sm" onClick={handleShowDel}><i className='fas fa-trash-alt'></i>&nbsp;Xóa</Button>: ''} */}
                </div>
            </div>
            <div className="card-body">
                <div className="">
                    <table className="table table-bordered" width="100%">
                        <thead>
                            <tr>
                                {/* <th className="col-checkbox"></th> */}
                                <th>Tài khoản</th>
                                <th>Người dùng</th>
                                <th>Nội dung</th>
                                <th>Thời gian</th>
                                <th>Địa chỉ Ip</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listNhomQuyens.map((item, key) => {
                                    return (
                                        <tr key={key}>
                                            {/* <td className="col-checkbox">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" checked={item.Checked} onChange={checkBoHandler} />
                                                </div>
                                            </td> */}
                                            <td>{item.UserName}</td>
                                            <td>{item.FullName}</td>
                                            <td>{item.NoiDung}</td>
                                            <td>{item.Ngay}</td>
                                            <td>{item.DiaChiIp}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="col-md-12 text-right">
                    <Pagination {...paginationConfig} />
                </div>
            </div>
        </div>

    )
}
